function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconesCac14Cinza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-40-43.141-40-63.936C-40-85.84-22.091-104 0-104s40 17.757 40 39.661C40-43.544 0 0 0 0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.11719 0 0 -.11719 16.875 22.5)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.11719 0 0 -.11719 16.875 5.977)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-36c0-44.183-35.817-80-80-80h-87c-44.183 0-80 35.817-80 80V0h472",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.11719 0 0 -.11719 31.29 44.063)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#263238",
      strokeOpacity: 1,
      fill: "#263238",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20S0-11.046 0 0",
    style: {
      fill: "#263238",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#263238",
      strokeOpacity: 1
    },
    transform: "matrix(.11719 0 0 -.11719 19.219 14.18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesCac14Cinza);
export default __webpack_public_path__ + "static/media/Icones_cac_14_cinza.3c1faca91b14ce8d5870364155933270.svg";
export { ForwardRef as ReactComponent };